module.exports = __webpack_public_path__ + "img/191-tonga.53f7a35d.svg";